export const badgeContainerStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '18px',
  height: '18px',
  padding: '0 6px',
  marginLeft: '8px',
  borderRadius: '9px',
  border: 'none',
  cursor: 'pointer',
  backgroundColor: ({ palette }) => palette.warning.dark,
};

export const badgeLabelStyles = {
  color: ({ palette }) => palette.common.white,
};
